exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".zones.inner-block u{color:#337ab7}.zero-opacity-cover{position:absolute;z-index:99999;height:100%;width:100%;opacity:0}.new-line{white-space:pre}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/main/panels/panel/zones.component/styles.less
 ** module id = 623
 ** module chunks = 0
 **/